import React from 'react';
import styled from 'styled-components';

import { Tooltip } from '@mui/material';

import { colors } from 'theme/colors';

import {
  InfoContainer,
  InfoDescription,
  InfoHeader,
} from 'containers/Users/components/AddUsersModal/components/RoleInfo/styles';

import { ACCESS_ROLES } from './data/access';
import { RoleInfoIcon } from './styles';

const RoleInfo: React.FC<{ className?: string }> = ({ className }): React.ReactElement => (
  <Tooltip
    componentsProps={{
      tooltip: {
        sx: {
          bgcolor: colors.common.white,
          boxShadow: `0px 3px 14px 2px ${colors.divider}, 0px 8px 10px 1px ${colors.grey[300]}, 0px 5px 5px -3px ${colors.grey[400]}`,
          borderRadius: '4px',
        },
      },
    }}
    title={
      <InfoContainer>
        {[...ACCESS_ROLES].reverse().map((role) => (
          <React.Fragment key={role.id}>
            <InfoHeader>{role.name}</InfoHeader>
            <InfoDescription>{role.description}</InfoDescription>
          </React.Fragment>
        ))}
      </InfoContainer>
    }
    placement="right"
  >
    <RoleInfoIcon fontSize="small" className={className} />
  </Tooltip>
);

export default RoleInfo;

export const RowRoleInfo = styled(RoleInfo)`
  margin: 12px 0 4px 8px;
`;
